import React from 'react';
import { Redirect } from 'react-router';

const RmsRoutes = props => {
  return <Redirect to={'/'} />;
};

export default RmsRoutes;
